// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__1IyF6","visibleHandle":"Handle_visibleHandle__2VR7x","dragged":"Handle_dragged__pVD2N"};